<div class="title-container" fxLayout="column" fxLayoutGap="0.5rem">
    <mat-divider *ngIf="data?.divider !== false"></mat-divider>
    <div *ngIf="data && data.title" class="fs-3 title" [innerHTML]="data.title | safeHtml"></div>
    <div *ngIf="data && data.price" class="fs-3 price">{{data.price | currency: 0 : '€' }}&nbsp;{{'landing.annualPrice' | translate}}</div>
    <div *ngIf="data && data.subtitle" class="fs-6 subtitle" [ngClass]="data.ngClass" [innerHTML]="data.subtitle | safeHtml"></div>

</div>